import { AUDIO_MODEL_DEFINITIONS } from './audio';
import { IMAGE_MODEL_DEFINITIONS } from './image';
import {
  ModelFamily,
  ModelRouteAdapter,
  ModelSurface,
  ModelTopology,
  ReferenceTransportStrategy,
  UnsupportedReferenceBehavior,
  mergeModelContracts,
  normalizeModelRepository,
} from './schema';
import { THREE_D_MODEL_DEFINITIONS } from './threed';
import { VIDEO_MODEL_DEFINITIONS } from './video';
import {
  buildTimingAliasMap,
  lookupTimingProfileForKey,
  resolveModelTimingAliasTopology,
} from './timingAliases';

export {
  ModelFamily,
  ModelRouteAdapter,
  ModelSurface,
  ModelTopology,
  ReferenceTransportStrategy,
  UnsupportedReferenceBehavior,
  mergeModelContracts,
  resolveModelTimingAliasTopology,
};

export const MODEL_DEFINITIONS = [
  ...IMAGE_MODEL_DEFINITIONS,
  ...VIDEO_MODEL_DEFINITIONS,
  ...THREE_D_MODEL_DEFINITIONS,
  ...AUDIO_MODEL_DEFINITIONS,
];

export const MODEL_REPOSITORY = normalizeModelRepository(MODEL_DEFINITIONS);

const MODEL_BY_ID = new Map(MODEL_REPOSITORY.map((model) => [model.id, model]));
const TIMING_ALIAS_BY_KEY = buildTimingAliasMap(MODEL_REPOSITORY);

function normalizeTimingLookupKey(value) {
  if (typeof value !== 'string') return null;
  const normalizedValue = value.trim();
  return normalizedValue || null;
}

export function getCatalogModelById(modelId) {
  const normalizedModelId = normalizeTimingLookupKey(modelId);
  if (!normalizedModelId) return null;
  return MODEL_BY_ID.get(normalizedModelId) || null;
}

export function getCatalogTimingProfileForKey(modelKey) {
  return lookupTimingProfileForKey({
    modelByIdMap: MODEL_BY_ID,
    timingAliasByKey: TIMING_ALIAS_BY_KEY,
    modelKey,
  });
}

export default MODEL_REPOSITORY;
